import Enumeration from 'Lib/utilities/Enumeration';

export const TimeLineLogTypes = new Enumeration([
    { id: 1, key: 'Created', name: 'Created' },
    { id: 2, key: 'Updated', name: 'Updated' },
    { id: 3, key: 'StatusUpdated', name: 'Status Updated' },
    { id: 4, key: 'NoteAdded', name: 'Note Added' },
    { id: 5, key: 'NoteModified', name: 'Note Modified' },
    { id: 6, key: 'NoteRemoved', name: 'Note Removed' },
    { id: 7, key: 'FileAttachmentAdded', name: 'File Attachment Added' },
    { id: 8, key: 'FileAttachmentRemoved', name: 'File Attachment Removed' },
    { id: 9, key: 'FileAttachmentModified', name: 'File Attachment Modified' },
    { id: 10, key: 'Printed', name: 'Printed' },
    { id: 11, key: 'Screened', name: 'Screening Report Run' },
    { id: 12, key: 'Completed', name: 'Completed' },
    { id: 13, key: 'Cancelled', name: 'Cancelled' },
    { id: 14, key: 'Declined', name: 'Declined' },
    { id: 15, key: 'Sent', name: 'Sent' },
    { id: 16, key: 'Opened', name: 'Opened' },
    { id: 17, key: 'Signed', name: 'Signed' },
    { id: 18, key: 'Approved', name: 'Approved' },
    { id: 19, key: 'VendorNotified', name: 'Vendor Notified' }
]);
